
	import {
		Component,
		Model,
		Prop,
		Vue,
		Watch
	} from "vue-property-decorator";

	import Dialog from '@/components/dialog.vue';

	import {
		employeeChargeProvider,
		employeeChargeProviderSave
	} from '@/api/auth.ts';
	import {
		providerSelectItem
	} from '@/api/supplier.ts';

	@Component({
		name: 'AllotProvider',
		components: {
			'allot-dialog': Dialog
		}
	})

	export default class AllotProvider extends Vue {
		
		@Model('change') visible!: Boolean;
		@Prop({default: 0}) id!: Number;
		private showDialog = false;
		private loading = false;
		private isReady = false;
		
		private providerList: any = [];
		private providerId: any = '';
		private tags: any = [];
		
		@Watch('visible')
		private async onChangeVisible(e) {
			this.showDialog = e;

			if (this.showDialog) {
				this.isReady = false;
				this.getProviderSelectItem()
				this.getEmployeeChargeProvider()
			}
		}

		//获取供应商列表
		private async getProviderSelectItem() {
			try {
				const res: any = await providerSelectItem({})
				this.providerList = res.Result;
			} catch (err) {}
		}
		//获取已负责的供应商列表
		private async getEmployeeChargeProvider() {
			try {
				const res: any = await employeeChargeProvider({
					EmployeeId: this.id
				})
				this.tags = res.Result;
				this.isReady = true;
			} catch (err) {
				this.isReady = true;
			}
		}

		
		//关闭弹框
		private handleClose() {
			this.providerId = '';
			this.tags = [];
			this.showDialog = false;
			this.$emit('change', false)
		}
		
		private async handleSave(){
			this.loading = true;
			try {
				const res: any = await employeeChargeProviderSave({
					EmployeeId: this.id,
					ProviderList: this.tags.map(item=>{
						return item.ProviderId
					})
				})
				
				if (res.IsSuccess){
					this.$message.success('保存成功');
					this.handleClose();
				}
				this.loading = false;
			} catch (err) {
				this.loading = false;
			}
		}
		
		/**
		 * 点击加入
		 */
		private doSearch(){
			if (!this.providerId){
				this.$message.error('请选择供应商');
				return;
			}
			
			let list = this.tags.filter(item=>{
				return item.ProviderId === this.providerId;
			})
			
			if (list.length){
				this.$message.error('选择的供应商已存在');
				return;
			}
			
			let array = this.providerList.filter(item=>{
				return item.Id === this.providerId;
			})
			
			this.tags.push({
				ProviderId: this.providerId,
				ProviderName: array[0].ProviderName
			})
		}
		
		/**
		 * 删除已选供应商
		 */
		private handleCloseTag(index){
			this.tags.splice(index, 1)
		}
		
	}
